// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2IYD0","info":"Note_info__2woEv","note":"Note_note__3C5Kv","actions":"Note_actions__2jvBk"};